<template>
  <transition name="fade">
    <v-card>
      <v-card-text>
        <v-overlay v-show="loader"> Cargando </v-overlay>
        <div>
          <v-form>
            <v-container>
              <v-autocomplete
                label="Seleccione un producto del listado"
                v-model="producto"
                item-value="id"
                item-text="Nombre"
                :items="comp_prod"
                dense
                outlined
              ></v-autocomplete>

              <v-row>
                <v-col md="12" cols="12">
                  <v-card v-if="producto != ''">
                    <v-card-title>Detalle de producto</v-card-title>
                    <v-card-text>
                      <h3>
                        <v-icon class="mr-2">mdi-package-variant</v-icon>
                        Existencia Actual: {{ comp_suggest_price.Stock }}
                        {{ Unidad }} <br />
                        <v-icon class="mr-2">mdi-currency-usd</v-icon> Precio
                        Actual: {{ comp_suggest_price.PV }} MXN
                      </h3>
                      <v-alert
                        v-if="comp_suggest_price.Stock == 0"
                        color="error"
                        dark
                      >
                        Este producto no tiene existencia en el almacén
                        seleccionado
                      </v-alert>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col md="12" cols="12">
                  <v-card v-if="producto !== ''">
                    <v-card-title>Detalle de Salida de Producto</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col md="12" cols="12">
                          <v-autocomplete
                            :items="presentacionesGlobal"
                            v-model="selectedPresentacion"
                            label="Presentaciones disponibles"
                            placeholder="Seleccione un producto"
                            item-text="title"
                            item-value="Id"
                          ></v-autocomplete>
                        </v-col>
                        <v-col md="12" cols="12">
                          <v-text-field
                            v-if="presentaciones.length > 0"
                            v-model="cantidadPres"
                            @keypress="
                              $pgsHelper.onlyNumber($event, cantidadPres)
                            "
                            label="Cantidad de la presentación"
                          >
                            <template v-slot:append-outer>
                              <v-btn
                                @click="calcularCantidadTransferir"
                                small
                                outlined
                              >
                                <v-icon>mdi mdi-calculator</v-icon> Calcular
                              </v-btn>
                            </template>
                          </v-text-field>
                          <v-text-field
                            v-model="cantidad"
                            readonly
                            disabled
                            :label="
                              'Cantidad de producto a transferir (' +
                              Unidad +
                              ')'
                            "
                          ></v-text-field>
                          <!-- <v-text-field
                            type="number"
                            v-model="cantidad"
                            step="any"
                            label="Cantidad de producto que saldrá del inventario"
                            outlined
                            dense
                          /> -->
                        </v-col>
                        <v-col md="12" cols="12">
                          <v-select
                            :items="comp_motivos"
                            v-model="motivo"
                            label="Seleccione un motivo"
                            outlined
                            dense
                          ></v-select>
                          <label class="mr-5">Registra un nuevo motivo</label>
                          <v-btn
                            color="primary"
                            small
                            @click="
                              keyformMotivo++;
                              showModalMotivo = true;
                            "
                          >
                            Agregar Motivo
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-right">
                  <v-btn color="success" class="mr-2" @click="checkForm()"
                    >Guardar</v-btn
                  >
                  <v-btn @click="$emit('toggle', false)" outlined
                    >Cancelar</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
        <modal
          v-model="showModalMotivo"
          :showFooter="false"
          title="Agregar nuevo Motivo"
        >
          <MotivoForm
            :key="keyformMotivo"
            @successData="saveMotivo"
            @toggle="showModalMotivo = false"
          ></MotivoForm>
        </modal>
      </v-card-text>
    </v-card>
  </transition>
</template>

<style>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import { ModelSelect } from "vue-search-select";
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import MotivoForm from "../../Inventarios/SalidaMercancias/MotivoForm.vue";
import PresentacionesAYB from "../../../clases/Restaurante/PresentacionesAYB";

export default {
  name: "ProductExistFormSalida",
  components: {
    //Select2,
    modal,
    MotivoForm,
    // ModelSelect,
  },
  props: ["edit", "dataEdit", "loadData", "Origen"],
  data() {
    return {
      showModalMotivo: false,
      keyformMotivo: 1,
      producto: "",
      actualExist: 0,
      actualPrice: 0,
      nombre: "",
      actualMoneda: "",
      cantidad: "",
      newPrice: 0,
      motivo: "",
      motivoNombre: "",
      Unidad: "",
      errors: {},
      loader: true,
      products: [],
      motivos: [],
      cantidadPres: 1,
      presentaciones: [],
    };
  },
  methods: {
    async getMotivos() {
      this.motivos = [];

      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Motivos"
        );
      if (data.exists()) {
        let arrayFactura = Object.entries(data.val());

        arrayFactura.forEach((element) => {
          this.motivos.push({ id: element[0], Nombre: element[1]["Nombre"] });
        });
      }
    },
    getDetail(productoId) {
      let producto = this.getProductoById(productoId);
      this.Unidad = producto?.Extra?.AYB?.UM || "PZA";
      this.actualExist = producto.Existencia;
      this.actualPrice = producto.Precio;
      this.newPrice = producto.Precio;
      this.nombre = producto.Nombre;
      this.actualMoneda = producto.Moneda;
    },
    getProductoById(code) {
      let producto = this.$store.getters.getProductos;
      let itemIndex = this.$_.findIndex(producto, { id: code });
      if (itemIndex >= 0) {
        return producto[itemIndex];
      }

      return false;
    },
    saveMotivo(datos) {
      let sendData = {
        Nombre: datos.motivo,
        Creacion: new moment().format("YYYY-MM-DD"),
      };
      this.$pgsHelper.log(sendData);
      this.$swal({
        title: "¿Deseas crear esta nuevo motivo?",
        text: "Se registrar el motivo indicado ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Productos-createMotivo", sendData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El Motivo se guardo corretamente",
              icon: "success",
            });
            this.getMotivos();
            this.showModalMotivo = false;
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    calcularCantidadTransferir() {
      let presentacion = this.$pgsHelper.getById(
        this.presentacionesGlobal,
        "Id",
        this.selectedPresentacion
      );

      if (presentacion) {
        this.cantidad = Number(presentacion.rdm) * Number(this.cantidadPres);
      }
    },
    checkForm() {
      let valid = true;

      this.errors = [];

      if (!this.producto) {
        this.errors.producto = "El producto es obligatorio";
        valid = false;
      } else {
        this.errors.producto = false;
      }

      if (!this.cantidad) {
        this.errors.cantidad = "La cantidad a retirar es obligatorio";
        valid = false;
      } else {
        this.errors.cantidad = false;
      }

      if (!this.motivo) {
        this.errors.motivo = "El motivo es obligatorio";
        valid = false;
      } else {
        this.errors.motivo = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/
      console.log(this.errors);
      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }

        this.motivos.forEach((element) => {
          if (element.id == this.motivo) {
            this.motivoNombre = element.Nombre;
          }
        });

        this.$emit("successData", this.$data, doAction);
      }
    },
    async getPresentaciones() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("AMC_Presentaciones", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      if (data.empty) {
        this.presentacionesArray = [];
      } else {
        let doc = data.docs.map((doc) => {
          return { Id: doc.ref.id, ...doc.data() };
        });
        this.presentacionesArray = doc;
      }
    },
    async getPresentacionesByProduct(id) {
      let data = await PresentacionesAYB.getPresentacionByProd(id,true);

      this.presentaciones = data;
    },
    // getDetail(productoId) {
    //   let producto = this.getProductoById(productoId);
    //   this.actualExist = producto.Existencia;
    //   this.nombre = producto.Nombre;
    //   this.actualPrice = producto.Precio;
    //   this.Unidad = producto?.Extra?.AYB?.UM || "PZA";
    //   this.codigo = producto.Codigo;
    //   this.actualMoneda = producto.Moneda;
    // },
  },
  computed: {
    comp_suggest_price() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let precio_existencia = "";

      origenes.forEach((origen, index) => {
        if (origen.Origen == this.Origen) {
          this.$pgsHelper.log(origen.Productos);
          this.$pgsHelper.log(this.producto);
          let OrProd = Object.entries(origen.Productos);
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == this.producto) {
              this.$pgsHelper.log("Existencia detectada");
              precio_existencia = oProducto[1];
            }
          });
        }
      });

      let returnData = { PCP: 0, PV: 0, PVP: 0, Stock: 0 };

      if (precio_existencia != "") {
        returnData = precio_existencia;
      }

      return returnData;
    },
    comp_prod() {
      try {
        if (!this.Origen) {
          return [];
        }
        let producto = this.$store.getters.getProductos;
        let origenes = this.$store.getters.getOrigenes;
        let listadoProductos = [];
        producto.forEach((element) => {
          let productoData = this.$pgsHelper.cloneObj(element);
          if (
            productoData.Tipo != "Servicio" &&
            productoData.Tipo != "Producto-NInv" &&
            productoData.Tipo != "AYB-Producto" &&
            productoData.Tipo != "AYB-ICompuesto" &&
            !productoData.Dlat
          ) {
            productoData.selectableProd = this.selectedAll;
            let centroConsumo = this.$pgsHelper.getById(
              origenes,
              "Origen",
              this.Origen
            );
            let productOrigen = null;
            if (centroConsumo) {
              if (centroConsumo.Productos[productoData.id]) {
                productOrigen = centroConsumo.Productos[productoData.id];
                productoData.existencia = Number(productOrigen.Stock) || null;
                productoData.unidad = productoData?.Extra?.AYB?.UM || "PZA";
              }
            }
            if (productoData.existencia >= 0) {
              if (productoData.existencia == 0) {
                productoData.existencia = 0;
              }
            }
            listadoProductos.push(this.$pgsHelper.cloneObj(productoData));
          }
        });
        let productosFiltrados = listadoProductos;
        return productosFiltrados;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    presentacionesGlobal() {
      let presentaciones = [];
      this.presentaciones.forEach((pres) => {
        let producto = this.$pgsHelper.getById(this.comp_prod, "id", pres.prd);

        pres.title =
          producto.Nombre +
          " - " +
          pres.nom +
          " - " +
          pres.rdm +
          " " +
          (producto.Extra?.AYB?.UM ? producto.Extra?.AYB?.UM : "PZA");

        presentaciones.push(pres);
      });
      return presentaciones;
    },
    comp_motivos() {
      let prov = [];
      this.motivos.forEach((element) => {
        prov.push({ value: element.id, text: element.Nombre });
      });

      return prov;
    },
  },
  watch: {
    producto(newVal) {
      this.selectedPresentacion = null;
      this.cantidadPres = 1;
      this.cantidad = 0;

      this.getDetail(newVal);
      this.getPresentacionesByProduct(newVal);
    },
  },
  beforeMount: function () {},
  mounted() {
    this.getMotivos();
    this.loader = false;
    if (this.edit) {
      this.nombre = this.dataEdit.Nombre;
    }
    if (this.loadData) {
      this.producto = this.loadData.ProductoId;
    }
  },
};
</script>
